<template>
  <div>
    <div class="container-fluid footer-wrapper" :style="styleObj">
      <div class="row footer-bootom-wrapper hidden-xs">
        <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
          <div class="container-fluid">
            <div class="row footer-content-wrapper">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 footer-content-item">
                <div class="footer-content-left">
                  <div class="footer-menu">
                    <span>首页</span>
                    <span>公司简介</span>
                    <span>产品和解决方案</span>
                    <span>服务领域</span>
                    <span>联系我们</span>
                  </div>
                  <div class="contact-wrapper">
                    <div>
                      <p class="contact-content">电话：020-37732627</p>
                      <p class="contact-content">邮箱：317820535@qq.com</p>
                      <p class="contact-content">电话：办公时间：Mon-Fri:8:30am-17:00pm</p>
                    </div>
                    <div>
                      <p class="contact-content">手机：18026382627</p>
                      <p class="contact-content">地址：广州市天河区华夏路49号之一</p>
                    </div>
                  </div>
                </div>
                <img src="../assets/home/QR_code.jpg" alt="" class="img"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom-wrapper" :style="bottomStyle">广州市同慧信息科技有限公司<span style="margin-left: 18px"><a target='blank' href='https://beian.miit.gov.cn'>粤ICP备20062960号-2</a></span></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      styleObj: {
        backgroundImage: `url(${require("../assets/footer-bg.png")})`,
      },
      bottomStyle: {
        backgroundImage: `url(${require("../assets/footer-bg2.png")})`,
      },
    };
  },
};
</script>
<style scoped>
.footer-wrapper {
  background-size: 100% 100%;
  color: #ffffff;
}
.footer-bottom-wrapper {
  text-align: center;
  width: 100%;
  height: 54px;
  font-size: 14px;
  font-weight: 500;
  color: #efefef;
  background-size: 100% 100%;
  line-height: 54px;
}
.footer-content-wrapper {
  padding: 0 62px;
}
.footer-menu {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #eeeeee;
}
.footer-menu > span {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  padding-right: 40px;
  padding-left: 10px;
}
.footer-content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-content-item > img {
  width: 76px;
  height: 76px;
  background-color: #ffffff;
}
.contact-wrapper {
  padding: 20px 0;
  display: flex;
}
.contact-wrapper > div:nth-child(2) {
  margin-left: 20px;
}
.contact-wrapper .contact-content {
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  color: #dddddd;
}
.footer-bootom-wrapper {
  border-top: 1px solid #ffffff;
}
@media (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue